import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

export const WindyRmaLegend = ({ customLegendStyle = legendStyle }) => {
  const { t } = useTranslation();

  return (
    <div style={customLegendStyle}>
      <div>
        <b>Reale Group {`${t("riskAssessment.highWind")}`} (ITA)</b>
      </div>
      <div>
        <span style={legendItemStyle("#2A81BC")}></span>1 - {t("levels.veryLow")}
      </div>
      <div>
        <span style={legendItemStyle("#A9DEA2")}></span>2 - {t("levels.low")}
      </div>
      <div>
        <span style={legendItemStyle("#FEFFBD")}></span>3 - {t("levels.medium")}
      </div>
      <div>
        <span style={legendItemStyle("#FEB05C")}></span>4 - {t("levels.high")}
      </div>
      <div>
        <span style={legendItemStyle("#D91C15")}></span>5 - {t("levels.veryHigh")}
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © Reale Group, {t("legend.dataFromRealeGroup")}
        </span>
      </div>
    </div>
  );
};
